import React, {Component} from 'react';
import requestQuote from '../../../../../../themes/app/assets/js/modules/requestQuote';

class Table extends Component {

  componentDidMount = () => {
    requestQuote();
  };

  state = {
    selected: ''
  };

  _onClick = (partId) => {
    if (partId === this.state.selected) {
      this.setState({
        selected: ''
      });
    } else {
      this.setState({
        selected: partId
      });
    }
  };

  _addPartToRequestQuoteForm = (partId, partTitle) => {
    document.getElementById('requestPartId').value = partId;
    document.getElementById('requestPartTitle').innerText = partTitle;
  };

  render() {

    const {parts, filters} = this.props;

    const selected = this.state.selected;

    return (
      <table className='o-ResponsiveTable c-PartsTable'>
        <thead className='c-PartsTable__head'>
        <tr>
          <th className='c-PartsTable__th'>Part</th>
          {filters.slice(0,10).map(filter => (
            <th className='c-PartsTable__th' key={filter.id}>
              {filter.title}
            </th>
          ))}
        </tr>
        </thead>

        {parts.map(part => (
          <tbody key={part.id} className='c-PartsTable__body'>
          <tr key={part.id} className='c-PartsTable__row' onClick={() => this._onClick(part.id)}>
            <td className='c-PartsTable__td' style={{whiteSpace :  'nowrap'}}>{part.title}</td>
            {filters.slice(0,10).map((filter, idx)=> (
              <td className='c-PartsTable__td' key={filter.id}>
                {part.values[filter.id]}
              </td>
            ))}
          </tr>
          <tr className='c-PartsTable__row c-PartsTable__row--expanded'
              style={{display: (selected === part.id) ? 'table-row' : 'none'}}>
            <td className='c-PartsTable__td' colSpan='9999'>
              <a href={part.url}>
                <img className='c-PartsTable__part-image' src={part.image}/>
              </a>
              <span className='c-PartsTable__part-actions'>
                {
                     part.dataSheetExists
                    ? <a
                    href={ (userLoggedIn ? `/part/datasheet/download/${part.id}` : '#' )}
                    className={userLoggedIn
                      ? 'button c-PartsTable__button--download'
                      : 'button c-PartsTable__button--download loginAccess__trigger'}
                    download>
                    Download Datasheet
                  </a>
                    : ''
                }
                <button
                  onClick={() => this._addPartToRequestQuoteForm(part.id, part.title)}
                  className={userLoggedIn
                    ? 'button button--blue-all c-PartsTable__button requestAQuote__trigger'
                    : 'button button--blue-all c-PartsTable__button loginAccess__trigger'}
                >
                  Request Quote
                </button>
                <a className='button button--blue c-PartsTable__button' href='/distributors'>How To Buy</a>
              </span>
              {part.isometric_image ? <img className='c-PartsTable__part-image' src={part.isometric_image}/> : ''}
            </td>
          </tr>
          </tbody>
        ))}
      </table>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/product/js/Table.js